import { DealerChannel } from '@monorepo/interfaces'

export const dealerChannels = Object.entries(DealerChannel).map(
  ([label, value]) => ({
    value,
    label,
  })
)
